var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-card',{attrs:{"title":"Ferienwohnung Sabrina","images":_vm.images,"seasonalPrices":_vm.seasonalPrices}})}
var staticRenderFns = []

export { render, staticRenderFns }